module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('vue-headful', {
    attrs: {
      "title": "SGP - Plano de Trabalho"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "planoTrabalho"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Plano de Trabalho\n          "), _vm._v(" "), (_vm.bloqueiaBotoes === false) ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closewindow($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "textoAlerta"
  }, [_vm._v("O Plano de Trabalho é somente para impressão. Alterações realizadas não serão salvas!")])]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Proposta',
        href: '/proposta/lista'
      }, {
        text: 'Imprime',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaDadosCadastrais"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Dados Cadastrais")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta, 'ds_codigo_projeto_erp') && !_vm._.isNull(_vm.proposta.ds_codigo_projeto_erp) ? _vm.proposta.ds_codigo_projeto_erp + ' - ' : ' ') + _vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
    return m.ds_municipio + '/' + m.ds_uf
  })), function(municipio) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Número de Participantes Diretos do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar w10"
  }, [_vm._v(_vm._s(_vm._.sumBy(_vm.proposta.publicos_alvo, function(p) {
    return parseInt(p.nr_participantes_diretos)
  })) + " pessoas")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Convenente")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), (_vm.proposta.entidade.contato) ? _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Contato")]), _vm._v(" "), (_vm.proposta.entidade && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? _c('td', {
    staticClass: "ressaltar"
  }, [_c('span', {
    attrs: {
      "proposta.entidade.contato.ds_telefone": ""
    }
  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)))]), _vm._v("    "), _c('span', {
    attrs: {
      "proposta.entidade.contato.ds_celular": ""
    }
  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body m0"
  }, [_c('div', {
    staticClass: "w100 m0"
  }, [_vm._v("\n                      Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)\n                    ")]), _vm._v(" "), _vm._l((_vm.dirigentes), function(dirigente) {
    return _c('div', [_c('table', {
      staticClass: "table table-condensed table-bordered lista w100 m0"
    }, [(dirigente.cargo) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w30"
    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._.has(dirigente, 'ds_estado_civil') ? _vm._.get(_vm.estadoCivil, dirigente.ds_estado_civil) : ''))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Telefone")]), _vm._v(" "), (dirigente.contato) ? _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))]) : _vm._e()])]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objeto")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prazo de Execução / Previsão de Início e Fim da Execução do Objeto")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(this.dataInicioExecucao, 'MM/YYYY')) + "  a  " + _vm._s(this.dataFimExecucao) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)\n                      ")]), _vm._v(" "), (_vm.proposta.projetoAprovado) ? _c('td', [(_vm.mostrarRef('projeto_periodo_execucao')) ? _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.nr_periodos),
      expression: "proposta.nr_periodos"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Número de Meses do Projeto",
      "name": "periodo",
      "type": "number",
      "min": _vm.projetoPeriodos,
      "max": _vm.proposta.periodo_vigencia
    },
    domProps: {
      "value": (_vm.proposta.nr_periodos)
    },
    on: {
      "change": _vm.atualizarPrazoExecucao,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "esmaecido"
  }, [_vm._v("* mínimo de " + _vm._s(_vm.projetoPeriodos) + " meses e máximo (vigência) de " + _vm._s(_vm.proposta.periodo_vigencia) + " meses")])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "quebraPagina"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaMetas"
    }
  }, [(_vm.proposta.projetoAprovado) ? _c('div', {
    staticClass: "nao_imprimir"
  }, [(_vm.mostrarRef('objetivo_especifico')) ? _c('div', {
    ref: "objetivos"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('objetivo-especifico', {
    attrs: {
      "editavel": false,
      "propsObjetivos": _vm.proposta.objetivos,
      "propsProposta": _vm.proposta
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.proposta.objetivos = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('metas')) ? _c('div', {
    ref: "metas"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('metas', {
    attrs: {
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsProposta": _vm.proposta,
      "atvSemMetas": _vm.atvSemMetas
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.proposta.metas = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mostrarRef('atividades')) ? _c('div', {
    ref: "atividades"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('atividades', {
    attrs: {
      "meses": _vm.proposta.nr_periodos,
      "propsMetas": _vm.proposta.metas,
      "propsAtividades": _vm.proposta.atividades,
      "propsProposta": _vm.proposta
    },
    on: {
      "atividadeAdicionada": function($event) {
        _vm.proposta.atividades = $event
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.proposta.projetoAprovado ? 'imprimir' : ''
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed m0 obj_met_atv"
  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
    return [_c('tr', {
      staticClass: "objetivo"
    }, [(objetivo.ds_descricao) ? _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
      return (_vm._.find(meta.objetivos, function(o) {
        return o.ds_descricao === objetivo.ds_descricao
      })) ? [_c('tr', {
        staticClass: "meta"
      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
        staticClass: "tag vertical"
      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "ressaltar"
      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
        staticClass: "ressaltar"
      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
        return (_vm._.find(atividade.metas, function(m) {
          return m.ds_descricao === meta.ds_descricao
        })) ? [_c('tr', {
          staticClass: "atividade"
        }, [(atividade.descricao) ? _c('td', [_c('span', {
          staticClass: "tag vertical"
        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                                    "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                                    mês e comprovar com "), _c('span', {
          staticClass: "ressaltar"
        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
        staticClass: "atividade atencao"
      }, [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
      staticClass: "meta atencao"
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "quebraPagina"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaCronogramaAtividades"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho w40 b1 b4"
  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho direita w10 b1"
  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(mes) {
    return _c('th', {
      staticClass: "centralizado b1 b2 b4",
      style: ('zoom:' + _vm.ganttZoom)
    }, [_vm._v(_vm._s(mes + 1))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.atividades), function(atividade) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar b3 b4"
    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "direita b3"
    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
    }))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
      return _c('td', {
        staticClass: "centralizado b2 b3 b4",
        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
      }, [_c('i', {
        staticClass: "fa fa-circle"
      })]) : _c('span', [_vm._v(" ")])])
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', [_vm._v("\n                      Referência: 1º mês do projeto em "), _c('span', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._.head(_vm.periodoMesAno)['mes'] + '/' + _vm._.head(_vm.periodoMesAno)['ano']))]), _vm._v("\n                      e " + _vm._s(_vm.periodoMesAno.length) + "º (último) mês do projeto em "), _c('span', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._.last(_vm.periodoMesAno)['mes'] + '/' + _vm._.last(_vm.periodoMesAno)['ano']))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_operacao)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "quebraPagina"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaRecursosFinanceiros"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Plano de Aplicação dos Recursos Financeiros")]), _vm._v(" "), _c('table', {
    staticClass: "w100"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
    return [_c('tr', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('td', {
      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado bl1 bl3"
    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado bl1 bl3"
    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
      staticClass: "direita bl1 bl2 bl3",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
    }))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
      return _c('tr', [
        [_c('td', {
          staticClass: "bl4 b3"
        }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
          staticClass: "adiantavel"
        }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
          staticClass: "esmaecido"
        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
          staticClass: "observacao esquerda"
        }, [_vm._v(_vm._s(item.observacao))])]), _vm._v(" "), _c('td', {
          staticClass: "centralizado b3"
        }, [_vm._v(_vm._s(item.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
          staticClass: "centralizado b3"
        }, [_vm._v(_vm._s(item.nr_periodo_final))]), _vm._v(" "), _c('td', {
          staticClass: "centralizado b3"
        }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
          staticClass: "centralizado b3"
        }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
          staticClass: "centralizado b3 bl2"
        }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))])]
      ], 2)
    })]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "quebraPagina"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.proposta.adiantamentos) ? _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.adiantamentos), function(adiantamento) {
    return _c('tr', [_c('td', {
      staticClass: "text-center w20"
    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
      staticClass: "text-center w40"
    }, [(adiantamento.origem === 1) ? _c('span', [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (adiantamento.origem === 5) ? _c('span', [_vm._v("Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center w40"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total adiantável")]), _vm._v(" "), _c('td', {
    staticClass: "text-center ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.proposta.adiantamentos, function(p) {
    return p.valor
  }))) + "   (" + _vm._s(_vm._f("percentage")(((_vm._.sumBy(_vm.proposta.adiantamentos, function(p) {
    return p.valor
  })) / (_vm.totalFBB + _vm.totalParceiro)))) + ")")])])], 2), _vm._v(" "), (((_vm.proposta.adiantamentos && _vm.proposta.adiantamentos.length === 0) || (!_vm.proposta.adiantamentos))) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "100%"
    }
  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaCronogramaAtividades"
    }
  }, [_c('div', {
    staticClass: "quebraPagina"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guiaDesembolso"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "zoom": "1"
    }
  }, [_vm._v("Cronograma de Desembolso (Cronograma Físico-financeiro)")]), _vm._v(" "), _vm._l((_vm._.keys(_vm._.groupBy(_vm.periodoMesAno, 'ano'))), function(ano) {
    return [_c('div', {
      staticClass: "anoDesembolso"
    }, [_vm._v(_vm._s(ano))]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade) {
      return [_c('table', {
        staticClass: "w100 juntos"
      }, [_c('caption', [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
        staticClass: "b3",
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Item")]), _vm._v(" "), _vm._l((12), function(c) {
        return _c('th', {
          staticClass: "b3",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s(_vm.meses[c - 1]))])
      })], 2), _vm._v(" "), _c('tr', [_vm._l((12), function(d) {
        return [_c('th', {
          staticClass: "b3"
        }, [_vm._v("Qtde")]), _c('th', {
          staticClass: "b3"
        }, [_vm._v("Valor")])]
      })], 2)]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
        staticClass: "b3"
      }, [_vm._v("Total da atividade")]), _vm._v(" "), _vm._l((12), function(mesAtv) {
        return [_c('td', {
          staticClass: "b3"
        }, [_vm._v(_vm._s(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'quantidade')))]), _vm._v(" "), _c('td', {
          staticClass: "b3"
        }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(atividade, ano, mesAtv, 'valor'))))])]
      })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((atividade.itens_orcamentos), function(item) {
        return [_c('tr', [_c('td', {
          staticClass: "b3"
        }, [_vm._v("(" + _vm._s(item.item.ds_type) + ") " + _vm._s(item.item.ds_description))]), _vm._v(" "), _vm._l((12), function(mesIte) {
          return [_c('td', {
            staticClass: "b3"
          }, [_vm._v(_vm._s(_vm.desembolsoMesAno(item, ano, mesIte, 'quantidade')))]), _vm._v(" "), _c('td', {
            staticClass: "b3 direita"
          }, [_vm._v(_vm._s(_vm._f("decimal2")(_vm.desembolsoMesAno(item, ano, mesIte, 'valor'))))])]
        })], 2)]
      })], 2)])]
    })]
  })], 2)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w100 imprimir"
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "direita"
  }, [_c('span', {
    staticStyle: {
      "font-size": "40px !important"
    }
  }, [_vm._v("Plano de Trabalho")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Fundação")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Proponente")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Terceiros")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Valor Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Parcela")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Origem")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Valor")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d38a8cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/PlanoTrabalho.vue
// module id = 1961
// module chunks = 2